import { RdCategory } from '@neo.tax/shared';

export const RD_CATEGORY_SINGULAR_LABELS: Record<RdCategory, string> = {
  [RdCategory.AccountingPayroll]: 'Accounting Payroll',
  [RdCategory.Cloud]: 'Cloud',
  [RdCategory.Contractor]: 'Contractor',
  [RdCategory.Employee]: 'Employee',
  [RdCategory.Legal]: 'Patent',
  [RdCategory.NonRd]: 'Not R&D',
  [RdCategory.Supply]: 'Supply',
  [RdCategory.Unknown]: 'Unknown',
  [RdCategory.Overhead]: 'Overhead',
};
